import { ColumnsFactory } from "../../../../../../shared/components/Grid/functions";

export const getColumnDefs = () => {
  return [
    ColumnsFactory.TextColumn("Sociedad", "sociedad"),
    ColumnsFactory.DecimalColumn("Horas Control", "nHorasControl"),
    ColumnsFactory.DecimalColumn("Horas Utilidad", "nHorasUtilidad"),
    ColumnsFactory.DecimalColumn("Total Horas", "nHorasTotal"),
    ColumnsFactory.DecimalColumn("% Control", "porcControl", {ipkTotalizar: false}),
    ColumnsFactory.DecimalColumn("% Utilidad", "porcUtilidad", {ipkTotalizar: false})
  ];
};